import { put, takeEvery, fork } from "redux-saga/effects";
import { ModalTypes } from "constants/navigation";

import {
  CloseDispatchingModalAction,
  navigateToDispatchingModal,
  NavigateToDispatchingModalAction,
  OpenDispatchingModalAction,
  setModalContext,
  updateModalContext,
} from "actions";

import { EID_REPORT, MODAL_CONTEXT } from "constants/actionTypes";

import { getModalLink, closeModal, pushHash } from "lib/navigation";
import { consignmentModalSagas } from "./consignments";
import { receivalLotModalSagas } from "./receivalLot";
import { nominationModalSagas } from "./nomination";
import { businessPaymentModalSagas } from "./businessPayments";
import { businessModalSagas } from "./business";
import { scanLabelModalSagas } from "./scanLabel";

function* onOpenAdvancedModal(action: OpenDispatchingModalAction) {
  const { context, modalType, returnTo, type: ignored, ...modalProps } = action;

  yield put(
    setModalContext(
      modalType,
      // Spread the context to cater to case where context is null
      { ...context },
    ),
  );

  // Use a two stage open to ensure context is set before modal opens.
  // This helps to prevent things such as formik from loading without the context that was passed to the action.
  yield put(navigateToDispatchingModal(modalType, modalProps, returnTo));
}

function* onCloseAdvancedModal(action: CloseDispatchingModalAction) {
  if (action.navigate !== false) {
    closeModal();
  }
  yield put(
    updateModalContext(action.modalType, {
      isOpen: false,
      values: null,
      isContextSubmitting: false,
    }),
  );
}

function onNavigateToAdvancedModal(action: NavigateToDispatchingModalAction) {
  const { modalType, modalProps, returnTo } = action;
  pushHash(getModalLink(modalType, modalProps, returnTo));
}

function* onEIDReportFetchBulkFailure() {
  yield put(
    updateModalContext(ModalTypes.EIDReport, {
      isOpen: false,
    }),
  );
}

export default function* modalSagas() {
  yield takeEvery(MODAL_CONTEXT.OPEN.ACTION, onOpenAdvancedModal);
  yield takeEvery(MODAL_CONTEXT.CLOSE.ACTION, onCloseAdvancedModal);
  yield takeEvery(MODAL_CONTEXT.OPEN.REQUEST, onNavigateToAdvancedModal);

  yield takeEvery(EID_REPORT.FETCH_BULK.FAILURE, onEIDReportFetchBulkFailure);

  // Allow the default open handler to run first, then allow for custom handling
  yield fork(consignmentModalSagas);
  yield fork(receivalLotModalSagas);
  yield fork(nominationModalSagas);
  yield fork(businessPaymentModalSagas);
  yield fork(businessModalSagas);
  yield fork(scanLabelModalSagas);
}
